import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { AuthService } from 'app/core/auth/auth.service';
import { catchError, of, Subscription, switchMap } from 'rxjs';

@Component({
  selector: 'app-service-login',
  template: ``, // Sin HTML
  styles: [] ,    // Sin CSS
  encapsulation: ViewEncapsulation.None,
      standalone: true,
      imports: [
          
      ],
})
export class ServiceLoginComponent implements OnInit, OnDestroy {

  private routeSubscription: Subscription | undefined;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private authService: AuthService // Inyecta tu servicio de autenticación
  ) { }

  ngOnInit(): void {
    this.routeSubscription = this.route.queryParams.subscribe(params => {
        const continueParam = params['continue'];
        const codeChallenge = params['code_challenge'];
        const codeChallengeMethod = params['code_challenge_method'];
        const client_id = params['client_id'];
        const state = params['state'];
        const scope = params['scope'];
        const responseType = params['response_type'];
        const redirect_uri = params['redirect_uri'];
        console.log('Parameters received for authorization flow:', { continueParam, codeChallenge, codeChallengeMethod, client_id, state, scope, responseType, redirect_uri });
        if (!continueParam || !codeChallenge || !codeChallengeMethod ||
            !client_id || !state || !scope || !responseType || !redirect_uri
        ) {
          console.error('Error: Missing required parameters (continue, codeChallenge, codeChallengeMethod, client_id, state, scope, responseType, redirect_uri).');
          this.router.navigate(['/error/400']);
          return;
        }
  
        this.authService.check().pipe(
          switchMap(isAuthenticated => {
            if (isAuthenticated) {
              console.log('User is authenticated, proceeding with authorization flow...');
              return of(true); // Indica que el usuario está autenticado
            } else {
              // Si no está autenticado, redirigir al formulario de login
              console.log('User is not authenticated, redirecting to sign-in...');
              this.router.navigate(['/sign-in'], {
                queryParams: {
                  continue: continueParam,
                  code_challenge: codeChallenge,
                  code_challenge_method: codeChallengeMethod,
                  client_id: client_id,
                  state: state,
                  scope: scope,
                  response_type: responseType,
                  redirect_uri: redirect_uri
                }
              });
              return of(false); // Indica que el usuario no está autenticado (redireccionado)
            }
          }),
          catchError(error => {
            console.error('Error checking authentication status:', error);
            this.router.navigate(['/error/500']);
            return of(false); // Considerar como no autenticado en caso de error
          })
        ).subscribe(isAuthenticated => {
          if (isAuthenticated) {
            console.log('User is authenticated, initiating authorization flow...');
            // Si el observable anterior emitió true (autenticado), iniciar el flujo
            this.initiateAuthorizationFlow(continueParam, codeChallenge, codeChallengeMethod,
              client_id, state, scope, responseType, redirect_uri
            );
          }
          // Si emitió false, la redirección al login ya se realizó en el switchMap
        });
      });
  }

  ngOnDestroy(): void {
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }

  private initiateAuthorizationFlow(
    continueParam: string,
    codeChallenge: string,
    codeChallengeMethod: string,
    client_id: string,
    state: string,
    scope: string,
    responseType: string,
    redirect_uri: string
  ): void {

    
    this.authService.initiateAuthorization(codeChallenge, codeChallengeMethod,
      client_id, state, scope, responseType, redirect_uri
    )
      .subscribe({
        next: (response: any) => {
          // Asumimos que el backend responde con el authorization_code directamente
          // o con una URL a la que redirigir con el código.
          if (response && response.code && response.redirect_uri) {
            const authorizationCode = response.code;
            const redirectUri = response.redirect_uri; // URL a la que redirigir
            const state = response.state; // Si el backend devuelve state

            let redirectUrl = `${redirectUri}?code=${authorizationCode}`;
            if (state) {
              redirectUrl += `&state=${state}`;
            }
            redirectUrl += `&continue=${continueParam}`;
            console.log('Redirigiendo a la URL de autorización con el código:', redirectUrl);
            window.location.href = redirectUrl;
          } 
          else {
            console.error('Error: Invalid response from authorization server.', response);
            this.router.navigate(['/error/500']);
          }
        },
        error: (error) => {
          console.error('Error initiating authorization flow:', error);
          this.router.navigate(['/error/500']);
        }
      });
      
  }
}